export const LOGIN_API_RESPONSE = 'LOGIN_API_RESPONSE';
export const LOGOUT_API_RESPONSE = 'LOGOUT_API_RESPONSE';
export const REMOVE_STORAGE = 'REMOVE_STORAGE';
export const FORGET_PASSWORD_API_RESPONSE = 'FORGET_PASSWORD_API_RESPONSE';
export const RESET_PASSWORD_API_RESPONSE = 'RESET_PASSWORD_API_RESPONSE';
